<template>
  <article class="share__other">
    <p class="title">更多神券</p>
    <ul>
      <li v-for="(item,index) in actList" :key="index" @click="openOther(item.sourceLink,item)">
        <img :src="item.pictureLink | image">
        <p class="shop__name ellipse">{{item.prizeList[0].desc.substring(4,item.prizeList[0].desc.length - 2)}}</p>
        <p class="coupon__money"><span>{{item.prizeList[0].discount}}</span>元</p>
        <p class="coupon__descript">（满{{item.prizeList[0].quota}}元可用）</p>
      </li>
    </ul>
    <jm-infinite-load ref="loadmore" @loadmore="loadmore" :loading="loading" />
  </article>
</template>

<script>
export default {
  data () {
    return {
      actList: [],
      pageNumber: 1,
      pageSize: 4,
      loading: false,
      actMore: true,
    }
  },
  methods: {
    openOther (url, item) {
      this.bury("share_coupon_1571229562021|13", JSON.stringify(item))
      location.href = url
    },
    getMoreAct () {
      let param = {
        pageNumber: this.pageNumber++,
        pageSize: this.pageSize
      }
      this.$axios.post("share/findWorkingActivity", param).then(res => {
        this.actList = this.actList.concat(res)
        //设置用户刷新延时，防止用户随意刷数
        setTimeout(() => {
          this.loading = false
        }, 500)
        // this.count--
      }).catch(error => {
        if (error.code === 402020004) {
          this.$toast({
            iconName: 'warning',
            msg: error.message
          })
        } else {
          this.actMore = false
        }
      });
    },
    loadmore () {
      this.loading = true
      if (this.actMore) {
        this.getMoreAct();
      } else {
        this.$refs.loadmore.loadEnd()
      }
    }
  },
  mounted () {
    this.getMoreAct();
  }
}
</script>

<style lang="scss" scoped>
.share__other {
  position: relative;
  z-index: 1;
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-left: 5.5px;
    li {
      display: inline-block;
      width: 182px;
      height: 194px;
      background-image: url("./../../assets/img/coupon-bg.png");
      background: -webkit-image-set(
        url("./../../assets/img/coupon-bg.png") 1x,
        url("./../../assets/img/coupon-bg@2x.png") 2x,
        url("./../../assets/img/coupon-bg@3x.png") 3x
      );
      background-size: 100%;
      text-align: center;
      cursor: pointer;
      img {
        margin-top: 15px;
        width: 68px;
        height: 30px;
        border-radius: 2px;
        background-color: #fff;
      }
      .shop__name {
        margin: 5px 20px 0;
        font-size: 12px;
        color: #ffffff;
      }
      .coupon__money {
        padding-left: 25px;
        font-family: DINAlternate-Bold;
        color: #ffffff;
        margin-top: 30px;
        text-align: left;
        span {
          font-size: 50px;
        }
      }
      .coupon__descript {
        margin-top: 5px;
        padding-left: 20px;
        opacity: 0.8;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        line-height: 12px;
        text-align: left;
      }
    }
  }
}
</style>